import { Button, Modal } from "antd";
import { useState } from "react";
import useDelete from "hooks/useDelete";

const RevertIssueGroup = ({ is_disabled, issue_group_id, refetch }) => {
  const [is_open, setOpen] = useState(false);

  const { is_deleting, _delete } = useDelete({
    path: `/issue_groups/${issue_group_id}`,
    onSuccess: () => [refetch(), setOpen(false)],
    success_message: "Usunięto powiązanie ze zgłoszeniem",
  });

  return (
    <>
      <Button disabled={is_disabled} onClick={() => setOpen(true)}>
        Cofnij zgloszenie zbiorcze
      </Button>
      {is_open && (
        <Modal
          style={{ top: 45 }}
          title="Potwierdzenie"
          open={is_open}
          onOk={_delete}
          okButtonProps={{ loading: is_deleting }}
          onCancel={() => setOpen(false)}
          cancelText="Anuluj"
          okText="Potwierdzam"
          okType="danger"
        >
          Czy na pewno chcesz cofnąć zgłoszenie zbiorcze?
        </Modal>
      )}
    </>
  );
};

export default RevertIssueGroup;
